module.exports = __webpack_public_path__ + "static/img/s13.77d06c48.png";